// توکن‌های طراحی ققنوس (docs/09-ux/design-system.md). رنگ وضعیت‌ها ثابت است (IA §4.5).

export const brand = {
  primary: { light: '#0f766e', dark: '#2dd4bf' },
  secondary: { light: '#7c3aed', dark: '#a78bfa' },
} as const;

export const surfaces = {
  light: { background: '#f5f7f8', paper: '#ffffff', sidebar: '#ffffff', divider: '#e2e8f0' },
  dark: { background: '#0f1417', paper: '#161d21', sidebar: '#12191c', divider: '#26323a' },
} as const;

/** وضعیت‌های ثابت (رزرو، تأییدشده، حاضر، در حال خدمت، انجام‌شده، غیبت، لغو) و عمومی. */
export const statusColors = {
  booked: '#2563eb',
  confirmed: '#0891b2',
  arrived: '#7c3aed',
  in_service: '#d97706',
  done: '#16a34a',
  no_show: '#dc2626',
  cancelled: '#64748b',
  active: '#16a34a',
  inactive: '#64748b',
  pending: '#d97706',
  error: '#dc2626',
} as const;

export type StatusTone = keyof typeof statusColors;

export const radius = { sm: 4, md: 8, lg: 12 } as const;

/** فاصله پایه MUI (px) به ازای Density. */
export const spacingUnit = { compact: 6, comfortable: 8 } as const;

export const layout = {
  headerHeight: 56,
  sidebarWidth: 248,
  sidebarCollapsedWidth: 64,
} as const;

export const fontFamily = ['Vazirmatn', 'Tahoma', 'system-ui', 'sans-serif'].join(', ');
